import { CartPolicy } from './types';
import { pass } from './cartLineHelpers';

export const uhxTwoItemCartPolicy: CartPolicy = (input, cart, meta) => {
  if (!cart || !meta.ultrahumanXAdded || !meta.removedLineId) return pass(input);
  if (
    cart.lines.edges.length !== 2 ||
    meta.removedLineId === meta.ultrahumanXAdded.id
  ) {
    return pass(input);
  }

  const lineItemsToRemove = Array.from(
    new Set([...(input.lineItemsToRemove ?? []), meta.ultrahumanXAdded.id]),
  );
  return {
    input: { ...input, lineItemsToRemove },
    reasons: ['2-item cart: remove UHX alongside the other line'],
  };
};
